import tag from "./tag.component";
import tagUrls from "./tag.urls";
import TagTransforms from "./tag.transforms";

const tagModule = angular
  .module("app.components.tag", [])
  .component("tagPage", tag)
  .service("TagTransforms", TagTransforms)
  .config(tagUrls);

export default tagModule;



// WEBPACK FOOTER //
// ./src/pages/tag/tag.module.js